import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
    // 基础地址，按环境自动切换（见 .env.development / .env.production）
    baseURL: process.env.VUE_APP_BASE_API + '/index.php',
    // 请求超时时间
    timeout: 60000
})

// 避免登录过期弹框重复弹出
let isReloginShown = false

// ==================== 请求拦截器 ====================
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Token'] = token
        }
        return config
    },
    error => Promise.reject(error)
)

// ==================== 响应拦截器 ====================
service.interceptors.response.use(
    response => {
        // 文件流 / 二进制等直接返回原始数据
        const responseType = response.config.responseType
        if (responseType === 'blob' || responseType === 'arraybuffer') {
            return response.data
        }

        const res = response.data

        // 后端未采用 { code, msg, data } 统一结构时，直接返回
        if (res === null || res === undefined || typeof res !== 'object' || res.code === undefined) {
            return res
        }

        // 业务状态码非 1 视为错误
        // 接口文档：1=成功 0=业务错误 -1=未登录 -2=登录过期 -3=无权限 -4=账号被禁用
        if (res.code !== 1) {
            switch (res.code) {
                case -1:
                case -2:
                    handleRelogin()
                    break
                case -3:
                    Message({ message: res.msg || '没有权限访问', type: 'error', duration: 3000 })
                    break
                case -4:
                    handleRelogin(res.msg || '账号已被禁用，请联系管理员')
                    break
                default:
                    Message({ message: res.msg || '请求失败', type: 'error', duration: 3000 })
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        }

        return res
    },
    error => {
        const { response } = error
        let message = '网络异常，请稍后重试'

        if (response) {
            // 接口文档约定 HTTP 状态码统一为 200，这里仅兜底处理网络层异常
            const res = response.data
            switch (response.status) {
                case 401:
                    handleRelogin()
                    message = '登录已过期，请重新登录'
                    break
                case 403:
                    message = '没有权限访问'
                    break
                case 404:
                    message = '请求资源不存在'
                    break
                case 500:
                    message = '服务器错误'
                    break
                default:
                    message = (res && res.msg) || `请求失败(${response.status})`
            }
        } else if (error.message && error.message.includes('timeout')) {
            message = '请求超时，请稍后重试'
        }

        Message({ message, type: 'error', duration: 3000 })
        return Promise.reject(error)
    }
)

// 登录过期处理：清 token 并跳转登录页
function handleRelogin(tip = '登录状态已过期，请重新登录') {
    if (isReloginShown) return
    isReloginShown = true
    MessageBox.confirm(tip, '提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(() => {
            localStorage.removeItem('token')
            router.push('/login')
        })
        .catch(() => { })
        .finally(() => {
            isReloginShown = false
        })
}

export default service
